import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { BaseEndpoint } from '../app.constants';
import { Calendar } from './calendar.model';
import { CalendarEventResult } from "./calendar-event-result.model";

@Injectable()
export class CalendarService {
    private calendareventresults: CalendarEventResult = new CalendarEventResult();

    constructor(
        private http: Http,
        @Inject(BaseEndpoint) private baseApiUrl: string,
        private adalService: AdalService) {
    }

    getCalendarEvents(pageNumber: number, pageSize: number, includeWeekends: boolean): Promise<any> {
        var url = this.baseApiUrl + "v1/calendarevents?pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&includeWeekends" + includeWeekends;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var newCalendarEventResults: CalendarEventResult = resp.json().body as CalendarEventResult;

                this.calendareventresults.calendarEvents = newCalendarEventResults.calendarEvents;
                this.calendareventresults.totalRecords = newCalendarEventResults.totalRecords;

                return this.calendareventresults;
            })
            .catch(this.handleError);
    }

    updateCalendarEvent(id: number, calendarevent: Calendar): Promise<string> {
        var url = this.baseApiUrl + 'v1/calendarevent/' + id;
        return this.http
            .put(url, calendarevent, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return "";
            })
            .catch(this.handleError);
    }

    addCalendarEvent(calendarevent: Calendar[]): Promise<number[]> {
        var url = this.baseApiUrl + 'v1/calendarevents';
        return this.http
            .post(url, calendarevent, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var newCalendarEventIds = resp.json().body as number[];
                newCalendarEventIds = this.calendareventresults.calendarEvents.map(a => a.id);
                return newCalendarEventIds;
            })
            .catch(resp => {
                var errors = resp.json().messages;
                if (errors)
                    return this.handleError(errors);
            });
    }

    deleteCalendarEvent(calendarEventId: number): Promise<boolean> {
        var url = this.baseApiUrl + 'v1/calendarevent/' + calendarEventId;
        return this.http
            .delete(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var success = !resp.json().hasErrors as boolean;
                if (success) {
                    var calendarEventIndex = this.calendareventresults.calendarEvents.findIndex(t => t.id == calendarEventId);
                    this.calendareventresults.calendarEvents.splice(calendarEventIndex, 1);
                }
                return success;
            })
            .catch(this.handleError);
    }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/calendar/calendar.service.ts